import { render, staticRenderFns } from "./RollNewList.vue?vue&type=template&id=ef612d34&scoped=true&"
import script from "./RollNewList.vue?vue&type=script&lang=js&"
export * from "./RollNewList.vue?vue&type=script&lang=js&"
import style0 from "./RollNewList.vue?vue&type=style&index=0&id=ef612d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef612d34",
  null
  
)

export default component.exports